import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Channel } from './channel';
import { Show } from './show';
import { GetShowResponse } from './get-show-response';
import { GetShowRequest } from './get-show-request';
import { map } from 'rxjs/operators';

@Injectable()
export class FmApiService {

  constructor(
    private http: HttpClient
  ) { }

  private rootUrl = 'https://app.endycahyono.com/first';
  // private rootUrl = 'https://xj5ldtkzwsgekvhk.azurewebsites.net';
  // private rootUrl = 'https://uspcahharhjy5eb4.apphb.com';
  // private rootUrl = 'http://localhost:55429';

  getChannels() {
    let url = this.rootUrl + '/firstmedia/v4/channel';
    let cmd = this.http.post<ChannelResponse>(url, {}, { observe: "response" }).pipe(map(response => {
      let r = response.body.Channels.map(channel => {
        let c: Channel = {
          Code: channel.Number,
          Name: channel.Name,
          LogoURL: channel.LogoUrl
        };
        return c;
      });
      return r;
    }));
    return cmd;
  }

  getShow(params: GetShowRequest) {
    let url = this.rootUrl + '/firstmedia/v4/schedule';
    let cmd = this.http.post<ScheduleResponse>(url, params, { observe: "response" }).pipe(map(response => {
      let r: GetShowResponse = {
        Channels: response.body.Channels.map(channel => {
          let c: Channel = {
            Code: channel.Number,
            Name: channel.Name,
            LogoURL: channel.LogoUrl
          };
          return c;
        }),
        Schedules: response.body.Schedules.map(schedule => {
          let s: Show = {
            ChannelCode: schedule.ChannelNumber,
            ShowTime: schedule.DateStart,
            Title: schedule.Title,
            Description: schedule.Description,
            Until: schedule.DateEnd,
            Length: 0,
            Channel: null
          };
          return s;
        })
      }
      return r;
    }));
    return cmd;
  }

  deleteCache(params) {
    let url = this.rootUrl + '/firstmedia/schedule/cache';
    let cmd = this.http.delete(url, { params: params, observe: "response" });
    return cmd;
  }

}

interface Schedule {
  ChannelNumber: string;
  DateStart: Date;
  DateEnd: Date;
  Title: string;
  Description: string;
}

interface Channel4 {
  Number: string;
  Name: string;
  LogoUrl: string;
}

interface ChannelResponse {
  Channels: Channel4[];
}

interface ScheduleResponse {
  Channels: Channel4[];
  Schedules: Schedule[];
}



// WEBPACK FOOTER //
// D:/OTHERS/FirstmediaShowSchedule/src/app/FMAPI/fm-api.service.ts